export default "__VITE_ASSET__DX2r7Qan__"